import type { MouseEventHandler, ReactNode } from 'react'
import { Maximize02Icon } from '@systemeio/icons'
import { useTranslation } from 'next-i18next'
import { usePostAttachmentsContext } from 'modules/attachments/components/context'
import { filterNotGalleryAttachments } from 'modules/attachments/utils/attachment-utils'

interface FullscreenGalleryButtonProps {
  id: number | string
  className?: string
}

const FullscreenGalleryButton = ({ id, className }: FullscreenGalleryButtonProps): ReactNode => {
  const { t } = useTranslation()
  const { attachments, setInitialGallerySlide, setIsGalleryVisible } = usePostAttachmentsContext()

  const handleOpenGallery: MouseEventHandler<HTMLButtonElement> = e => {
    e.stopPropagation()

    const galleryAttachments = filterNotGalleryAttachments(attachments || [])

    setInitialGallerySlide(galleryAttachments?.findIndex(attachment => attachment.id === id))
    setIsGalleryVisible(true)
  }

  return (
    <button
      type="button"
      className={className}
      onClick={handleOpenGallery}
      aria-label={t('post.attachments.open_gallery')}
    >
      <Maximize02Icon className="size-8 text-text-on" />
    </button>
  )
}

export default FullscreenGalleryButton
